import styled from '@emotion/styled';
import { useNavigate } from 'react-router';
import { PrimaryButton } from '../styled-components';

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  background: 'var(--bg-base)',
  gap: 16,
  textAlign: 'center',
  padding: '0 24px',
});

const Code = styled.div({
  fontSize: 96,
  fontWeight: 700,
  fontFamily: "'JetBrains Mono', monospace",
  color: 'var(--accent-cyan)',
  lineHeight: 1,
  opacity: 0.25,
  userSelect: 'none',
});

const Title = styled.div({
  fontSize: 18,
  fontWeight: 600,
  color: 'var(--text-primary)',
});

const Body = styled.div({
  fontSize: 14,
  color: 'var(--text-secondary)',
  maxWidth: 300,
});

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <Code>404</Code>
      <Title>Page not found</Title>
      <Body>The page you're looking for doesn't exist or may have been moved.</Body>
      <PrimaryButton style={{ marginTop: 8 }} onClick={() => navigate('/')}>
        Go to dashboard
      </PrimaryButton>
    </Wrapper>
  );
}
